import { Table, Tag} from "antd";
export default function DataTable({ data }) {
  const columns = [
    {
      title: "Proyecto",
      dataIndex: "proyecto",
      sorter: (a, b) => a.proyecto.localeCompare(b.proyecto),
      width: 220,
    },
    {
      title: "Fecha",
      dataIndex: "fecha",
      sorter: (a, b) => a.fecha.localeCompare(b.fecha),
      width: 120,
      align: "center",
      render: (value) => (
        <span style={{ fontWeight: 500 }}>
          {value.substring(0, 2)}/{value.substring(2, 4)}/{value.substring(4, 8)}
        </span>
      ),
    },
    {
      title: "Día",
      dataIndex: "dia",
      sorter: (a, b) => a.dia.localeCompare(b.dia),
      width: 50,
      align: "center",
    },
    {
      title: "Mes",
      dataIndex: "mes",
      align: "center",
      sorter: (a, b) => a.mes.localeCompare(b.mes),
      width: 50,
    },
    {
      title: "Año",
      dataIndex: "anio",
      align: "center",
      sorter: (a, b) => a.anio.localeCompare(b.anio),
      width: 50,
    },

    {
      title: "Acompañamiento",
      dataIndex: "acompanamiento",
      width: 150,
      align: "center",
      render: (value) =>
        value === "X" ? <Tag color="blue">X</Tag> : <Tag>-</Tag>,
    },
    {
      title: "Capacitación",
      dataIndex: "capacitacion",
      width: 120,
      align: "center",
      render: (value) =>
        value === "X" ? <Tag color="green">X</Tag> : <Tag>-</Tag>,
    },
    {
      title: "Archivo",
      dataIndex: "archivo",
      ellipsis: true,
      width: 350,
    },
  ];

  return (
    <div style={{ marginBottom: 24, marginLeft: 13 }}>
      <Table
        dataSource={data}
        columns={columns}
        rowKey={(record) => `${record.proyecto}-${record.archivo}`}
        pagination={{ pageSize: 10 }}
        scroll={{ x: "max-content" }}
        locale={{ emptyText: "No hay datos disponibles" }}
      />
    </div>
  );
}
